import { graphql } from 'gatsby';

import { SapForm } from '@mewa/ui';

import { ComponentProps, PossibleContentSections } from '../fragment-and-types';
import { ContentLivePreviewConfig } from '../live-preview/types';

export const SapFormFragment = graphql`
  fragment SapFormFragment on STRAPI__COMPONENT_SHARED_SAP_FORM {
    headline
    sapFormDescription
    scrollToFormButtonLabel
    html
    strapi_component
  }
`;

export const componentName = 'shared.sap-form';

export type SapFormData = {
  headline: string;
  sapFormDescription: string | null;
  scrollToFormButtonLabel: string;
  html: string;
  strapi_component: typeof componentName;
};

export type SapFormPreview = SapFormData;

export const isSapForm = (
  component: PossibleContentSections,
): component is SapFormData => {
  return component.strapi_component === componentName;
};

export const StrapiSapForm = ({
  html,
  headline,
  sapFormDescription,
  id,
}: ComponentProps<SapFormData>) => (
  <SapForm
    id={id}
    html={html}
    scriptUrl="/sap-form-scripts/sapContentPage.js"
    headline={headline}
    description={sapFormDescription}
  />
);

export const config = {
  isComponent: isSapForm,
  Component: StrapiSapForm,
  componentName,
};

export const previewConfig: ContentLivePreviewConfig = {
  componentName,
  populationParams: {},
  mapProperties: (sapForm): SapFormData | null =>
    sapForm.strapi_component === componentName ? sapForm : null,
};
